import Group16 from '@carbon/icons-react/es/group/16';
import ViewOff16 from '@carbon/icons-react/es/view--off/16';
import React, { FC } from 'react';
import styled from 'styled-components';
import { IconShell } from 'components/atoms/icon-shell';
import { SpaceIcon } from 'components/atoms/space-icon';
import { TextWrapper, Title } from './styles';

const SpacePrivateIcon = styled.div`
  position: absolute;
  right: 4px;
  top: 4px;
`;

export const RenderProjectSpaceName: FC<{
  spaceName: string;
  onClick(): void;

  isPrivate: boolean;
}> = ({ onClick, spaceName, isPrivate }) => {
  return (
    <TextWrapper onClick={onClick}>
      <IconShell icon={<SpaceIcon name={spaceName} />} size="xsmall" />
      <Title ellipsis={{ tooltip: true }}>{spaceName}:</Title>
      <SpacePrivateIcon>
        {isPrivate ? <ViewOff16 /> : <Group16 />}
      </SpacePrivateIcon>
    </TextWrapper>
  );
};
